export default __webpack_public_path__ + "static/media/bys_logo_vert.bb71e104.svg";